export const RegisterActionTypes = {
  REGISTER_LOADING: "REGISTER_LOADING",
  REGISTER_ERROR: "REGISTER_ERROR",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
};
